import { getQueryString } from "@/utils/location"

/**
 * 保存字幕参数
 * @param param
 */
export function saveSrtParamsStyle(param) {
  const srtparam = localStorage.getItem('srtparam')
  const articleId = getQueryString('articleId')
  if (srtparam) {
    let objParamList: Array<any> = JSON.parse(srtparam)
    let objParamIndex = objParamList.findIndex(item => item.articleId == articleId)
    if (objParamIndex !== -1) {
      let objParam = objParamList[objParamIndex]
      objParam = {articleId, ...objParam, ...param}
      objParamList.splice(objParamIndex, 1, objParam)
    } else {
      objParamList.push({articleId, ...param})
    }
    localStorage.setItem('srtparam', JSON.stringify(objParamList))
  } else {
    localStorage.setItem('srtparam', JSON.stringify([{articleId, ...param}]))
  }
}

/**
 * 获取字幕参数
 * @returns
 */
export function getSrtParamsStyleByArticleId() {
  const articleId = getQueryString('articleId')
  const srtparam = localStorage.getItem('srtparam')
  if (srtparam) {
    const objParamList: Array<any> = JSON.parse(srtparam)
    return objParamList.find(item => item.articleId == articleId)
  }
  return {}
}